import type { BraintreePayPalCheckout } from '@paypal/react-paypal-js/dist/types/types/braintree/paypalCheckout';

import type { Locale } from '@change-corgi/config/locales';
import { getPaypalLocale } from '@change-corgi/config/paypal';

type CreateBillingAgreementParams = {
	currency: string;
	locale: Locale;
	paypalCheckout: BraintreePayPalCheckout | null;
	billingAgreementDescription?: string;
};

export async function createBillingAgreement({
	currency,
	locale,
	paypalCheckout,
	billingAgreementDescription,
}: CreateBillingAgreementParams): Promise<string> {
	if (!paypalCheckout) {
		return Promise.reject(new Error('No paypal checkout instance'));
	}

	return paypalCheckout.createPayment({
		billingAgreementDescription,
		currency,
		displayName: 'Change.org',
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		flow: 'vault' as paypal.FlowType.Vault,
		locale: getPaypalLocale(locale),
	});
}
